<template>
  <a-table
    class="table datatable thead-light dq-report-table"
    :columns="columns"
    :data-source="dataSource"
    :loading="loading"
    :pagination="pagination"
    @change="onChange"
    row-key="key"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key === 'Employee'">
        <div class="d-flex align-items-center">
          <div class="ms-0">
            <p class="text-dark mb-0">{{ record.employee_name }}</p>
            <span class="fs-12">
              {{ record.employee_id }}
              <span v-if="record.designation"> • {{ record.designation }}</span>
              <span v-if="record.department"> • {{ record.department }}</span>
            </span>
          </div>
        </div>
      </template>

      <template v-else-if="column.key === 'Date'">
        {{ record.date_label || record.date }}
      </template>

      <template v-else-if="column.key === 'Amount' || column.key === 'Balance'">
        <span
          v-if="
            record[column.dataIndex] !== null &&
            record[column.dataIndex] !== undefined
          "
        >
          {{ currency }}
          {{
            Number(record[column.dataIndex] || 0).toLocaleString(undefined, {
              minimumFractionDigits: 2,
            })
          }}
        </span>
        <span v-else class="text-muted">—</span>
      </template>
    </template>
  </a-table>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  rows: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  currency: { type: String, default: "KES" },
  total: { type: Number, default: 0 },
  pageSize: { type: Number, default: 25 },
  current: { type: Number, default: 1 },
});

const emit = defineEmits(["change"]);

const columns = [
  { title: "Date", dataIndex: "date_label", key: "Date" },
  { title: "Employee", dataIndex: "employee_name", key: "Employee" },
  {
    title: "Savings Account Name",
    dataIndex: "savings_account_name",
    key: "AccountName",
  },
  { title: "Amount", dataIndex: "amount", key: "Amount" },
  // { title: "Balance", dataIndex: "balance", key: "Balance" },
];

const dataSource = computed(() =>
  (props.rows || []).map((r, idx) => ({
    key: r.id || idx,
    date: r.date,
    date_label: r.date_label,
    employee_id: r.employee_id,
    employee_name: r.employee_name,
    department: r.department,
    designation: r.designation,
    savings_account_name: r.name,
    // savings_type: r.savings_type,
    amount: r.amount,
    // balance: r.balance,
  })),
);

const pagination = computed(() => ({
  total: props.total,
  pageSize: props.pageSize,
  current: props.current,
  showTotal: (t) => `Total ${t} items`,
}));

function onChange(pagination, filters, sorter) {
  emit("change", pagination, filters, sorter);
}
</script>

<style scoped>
@media (max-width: 767.98px) {
  :deep(.dq-report-table .ant-table) {
    min-width: 760px;
  }

  :deep(.dq-report-table .ant-table-cell) {
    vertical-align: top;
    white-space: normal;
  }
}
</style>
